import { Serializable } from "./serializable";

export class ChartDataPoint implements Serializable<ChartDataPoint> {
  private _id: string = "";
  public date: Date = null;
  public name: string = "";
  public value: number = 0;
  public unit: string = "";
  public type: string = "";
  public min: number = null;
  public max: number = null;

  /**
   * Gets entity id
   * @returns entity id
   */
  getId(): string {
    return this._id;
  }

  /**
   * Transforms received object to Chart data point entity
   * @param input
   * @returns Characteristic entity
   */
  deserialize(input: any = {}): ChartDataPoint {
    if (!input) {
      return null;
    }

    const properties = Object.getOwnPropertyNames(this);
    Object.keys(input).forEach((key) => {
      if (input[key] !== null) {
        switch (key) {
          case "id":
            this._id = input[key];
            break;
          default:
            if (properties.includes(key)) {
              this[key] = input[key];
            }
            break;
        }
      }
    });

    return this;
  }

  /**
   * Transforms Chart data point entity to json object
   * @returns json object
   */
  public serialize(): any {
    const output = {};

    Object.getOwnPropertyNames(this).forEach((property) => {
      switch (property) {
        case "_id":
          if (this[property]) {
            output["id"] = this[property];
          }
          break;
        default:
          output[property] = this[property];
          break;
      }
    });

    return output;
  }
}
